import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { CustomRegex } from "./CustomRegex";
import { ErrorMessage } from "./ErrorMessage";

export class ValidationService {
    public static getValidatorErrorMessage(
        validatorName: string,
        validatorValue?: any,
        controlError?: any,
        inputElmControl?: any
    ) {
        const message = controlError.message;
        const value = controlError.value;
       const config: any = {
    required: inputElmControl.value + ' ' + ErrorMessage.required,
    invalidEmailAddress: ErrorMessage.invalidEmail,
    numberOnly: 'Please Enter Number Only',
    atLeastOneRequired: 'Atleast One Value Required',
    samePassword: 'New password must be different from current password',
    strongPassword: 'Password must be at least 8 characters and include 1 digit and 1 special character'
};

        return config[validatorName];
    }
    public static strongPassword(control: any): any {
    if (!control.value) {
        return null; // let `required` handle empty case separately
    }
    if (!CustomRegex.password.test(control.value)) {
        return {
            strongPassword: true,
            message: 'Password must be at least 8 characters and include 1 digit and 1 special character',
            value: control.value,
        };
    }
    return null;
}



    /**
   * This function is uses for validate blank or empty input value.
   * @param control
   * @returns {any}
   */
    public static required(control: any): any {
        if (typeof (control.value) === 'number') {
            control.value = control.value.toString();
        }
        // RFC 2822 compliant regex
        if (!control || !control.value || !control.value || control.value.toString().trim() === '') {
            return {
                required: true,
                message: ErrorMessage.required,
                value: control.value,
            };
        } else {
            return null;
        }
    }


    static minSelectedCheckboxes(min: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control instanceof FormArray) {
                const selectedCount = control.controls.filter((checkbox) => checkbox.value).length;

                // Check if the number of selected checkboxes is less than the minimum required
                return selectedCount >= min ? null :  { 'minSelected': { value: selectedCount }  };

                // return selectedCount >= min ? null : {
                //     atLeastOneRequired: true,
                // };;

            }
            return null; // If not a FormArray, return null to avoid breaking the validation flow
        };
    }

    /**
   * email validation
   * @param control
   * @returns {any}
   */
    public static emailValidator(control: any, isEmailRecipient = false): any {
        // RFC 2822 compliant regex
        let emailValue: any;
        if (isEmailRecipient) {
            emailValue = control;
        } else {
            emailValue = control.value;
        }
        if (emailValue != null && emailValue !== undefined && emailValue.match(CustomRegex.email)) {
            return null;
        } else {
            return {
                invalidEmailAddress: true,
            };
        }
    }

    // public static allowNumberOnly(control: any, isSmsRecipient = false): any {
    //     let mobileNumber;
    //     if (isSmsRecipient) {
    //         mobileNumber = control;
    //     } else {
    //         mobileNumber = control.value;
    //     }
    //     if (mobileNumber === undefined || mobileNumber === '' || (mobileNumber && mobileNumber.match(CustomRegex.allowNumberOnly))) {
    //         return null;
    //     } else {
    //         if (!isSmsRecipient) {
    //             const controlName = ValidationService.getControlName(control);
    //             let errorString = null;
    //             if (controlName === 'mobile' || controlName === 'mobileNumber' || controlName === 'phoneNumber') {
    //                 return {
    //                     numberOnly: true,
    //                 };
    //             } else if (controlName === 'phone' || controlName === 'mobileNumber' || controlName === 'contactPersonPhone' || controlName === 'phoneNumber') {
    //                 return {
    //                     invalidEmailAddress: true,
    //                 };
    //             } else {
    //                 return {
    //                     invalidEmailAddress: true,
    //                 };
    //             }
    //             return { [errorString]: true };
    //         } else {
    //             return true;
    //         }
    //     }
    // }

    public static allowNumberOnly(control: any, isSmsRecipient = false): any {
        debugger
        let mobileNumber;
        if (isSmsRecipient) {
            mobileNumber = control;
        } else {
            mobileNumber = control.value.number;
        }
        if (mobileNumber === undefined || mobileNumber === '' || (mobileNumber && mobileNumber.match(CustomRegex.allowNumberOnly))) {
            return null;
        } else {
            if (!isSmsRecipient) {
                const controlName = ValidationService.getControlName(control);
                let errorString = null;
                if (controlName === 'mobile' || controlName === 'mobileNumber' || controlName === 'phoneNumber') {
                    return {
                        numberOnly: true,
                    };
                } else if (controlName === 'phone' || controlName === 'mobileNumber' || controlName === 'contactPersonPhone' || controlName === 'phoneNumber') {
                    return {
                        invalidEmailAddress: true,
                    };
                } else {
                    return {
                        invalidEmailAddress: true,
                    };
                }
                return { [errorString]: true };
            } else {
                return true;
            }
        }
    }

    public static getControlName(control: AbstractControl): string | null {
        if (control && control.parent instanceof FormGroup) {
            const formGroup = control.parent.controls;
            // Loop through the keys and check if the control is the same as the one from the formGroup
            return Object.keys(formGroup).find((name) => formGroup[name] === control) || null;
        }
        return null; // Return null if control or control.parent is invalid
    }
}
